<!-- компонент для рисования шаблонов в VDS -->
<template>
	<span>
		<!-- селектор фильтра -->
		<div v-if="isNeedShowFilter" class="w5-vds-plan-list-filter-wrapper">
			<span class="w5-vds-plan-list-filter first" :class="{ 'active': activeFilter === 'without-panel' }" @click.prevent.stop="toggleFilter('without-panel')">{{ 'service/without_panel' | ftc }}</span>
			<br class="visible-xs" />
			<span class="w5-vds-plan-list-filter" :class="{ 'active': activeFilter === 'with-panel' }" @click.prevent.stop="toggleFilter('with-panel')">{{ 'service/with_panel' | ftc }}</span>
			<br v-if="action === 'create'" class="visible-xs" />
			<span v-if="action === 'create' || action === 'view'" class="w5-vds-plan-list-filter last" :class="{ 'active': activeFilter === 'backup' }" @click.prevent.stop="toggleFilter('backup')">{{ 'service/backup' | ftc }}</span>
		</div>
		<div v-else class="margin-top-5"></div>
		<!-- ================ -->

		<!-- группы шаблонов -->
		<div v-if="activeFilter === 'without-panel' || activeFilter === 'with-panel'" class="w5-vds-plan-list-block template">
			<div v-for="(group, key, idx) in List"
				v-if="isTemplateVisible(group)"
				:key="key"
				class="w5-vds-plan-list-item template_id"
				:class="{
					'not-active-item': !isActiveTemplate(group),
					'not-for-current-plan': isNotGroupForPlan(group),
					'for-users': $store.state.user_type === 'client',
					'selected': isSelectedVersion(group.list)
				}"
				@click.prevent.stop="handleClick(key)">

				<!-- верхняя, общая часть -->
				<div class="w5-vds-plan-list-item-up" :class="{ 'full-and-round': activeFilter === 'with-panel' }">
					<img :src="APIServerUrl + group.image" width="64" />
					<div class="gourp-title">
						<strong>{{ group.list.length === 1 && group.list[0].fullName ? group.list[0].fullName : key }}</strong>
					</div>
				</div>

				<!-- нижняя, для каждого шаблона своя, часть. требуется только для шаблонов без панели -->
				<template v-if="activeFilter === 'without-panel'">

					<!-- если шаблонов несколько - нужен селектор -->
					<div v-if="group.list.length > 1" class="w5-vds-plan-list-item-down template_id" :class="{ 'border-none': group.showList }" style="position: relative">
						<div class="corner" :class="{ 'for-open-block': group.showList }"></div>
						<div v-if="group.showList" class="selector">
							<!-- версия шаблона - конкретный шаблон -->
							<div v-for="(temp, idx) in group.list"
								v-if="temp.version"
								:class="{ 'last': idx === group.list.length - 1, 'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || temp.plans.indexOf(curPlan) < 0 }"
								@click.prevent.stop="handleSelectTemplate(temp)">
								{{ temp.version }}
							</div>
						</div>
						<span v-else-if="isSelectedVersion(group.list)" class="item-with-only-text">{{ isSelectedVersion(group.list).version }}</span>
						<span v-else class="item-with-only-text">{{ 'template/select_version' | ftc }}</span>						
					</div>

					<!-- если в списке всего один шаблон -->
					<div v-else-if="group.list.length === 1" class="w5-vds-plan-list-item-down template_id">
						<!-- без версии -->
						<span v-if="!group.list[0].version" class="item-with-only-line"><div class="line"></div></span>
						<!-- с одной единственной версией (а значит без списка) -->
						<span v-else class="item-with-only-text">{{ group.list[0].version }}</span>
					</div>

				</template>

			</div>
		</div>
		<!-- резервные копии -->
		<div v-else-if="activeFilter === 'backup'" class="w5-vds-plan-list-block template">
			<div v-if="backupField && backupField.list && backupField.list.length" class="w5-field removeRightPadding">
				<backupChoiceComponent
					v-model="curBackup"
					:list="backupField && backupField.list ? backupField.list : []"
					:plan="curPlan"
					@focus="onBackupFocus"
					@input="onSelectValue" />
				<div v-show="backupField._errMsg"
					class="alert alert-danger w5-alert-valid"
					role="alert"
					v-withSafeTags="localeFtc(backupField._errMsg)" />
			</div>
			<div v-else class="empty-backup-list">
				<span v-if="accountField && accountField.value" class="empty-message">
					{{ 'service/backup_list_empty' | ftc }}
					<br>
					<a v-if="AppName === 'vdsina'" href="https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
						{{ 'backup/hint_how_to_make' | ftc }}
					</a>
					<a v-if="AppName === 'vdsina.com'" href="https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
						{{ 'backup/hint_how_to_make' | ftc }}
					</a>
					<a v-else-if="AppName === 'macloud'" href="https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
						{{ 'backup/hint_how_to_make' | ftc }}
					</a>
				</span>
				<span v-else  class="empty-message">{{ 'main/empty_table' | ftc }}</span>
				<div v-if="backupField && backupField._errMsg"
					class="alert alert-danger w5-alert-valid"
					role="alert"
					v-withSafeTags="localeFtc(backupField._errMsg)" />
			</div>
		</div>
		<!-- ================ -->
	</span>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
import Helper from '@/helper/helper'
import Multiselect from 'vue-multiselect'
import backupChoiceComponent from '@/components/elements/backup'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'templateComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['Field', 'crud', 'action', 'value', 'oldValue', 'backupField', 'accountField'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущее значение фильтра
			// если пустое - вообще не показывать фильтр
			activeFilter: '',
			// здесь собраны все группы шаблонов
			Groups: {
				'without-panel': {},
				'with-panel': {}
			},
			// текущее выбранное значение (выбранный шаблон)
			curValue: null,
			// старые значение - кешируем при смене фильтра
			oldValues: {
				'without-panel': null,
				'with-panel': null
			},
			// текущий выбранный бэкап
			curBackup: null,
			// фокус на поле бэкапа
			fieldFocused: false,
			// текущий выбранный план
			curPlan: null
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		//---------------------------------------------------------------------
		// список шаблонов согласно текущему фильтру
		//---------------------------------------------------------------------
		List() {
			if (!this.activeFilter)
			{
				return Object.keys(this.Groups['without-panel']).length
					? this.Groups['without-panel']
					: this.Groups['with-panel']
			}
			else if (this.activeFilter === 'without-panel')
			{
				return this.Groups['without-panel']
			}
			else if (this.activeFilter === 'with-panel')
			{
				return this.Groups['with-panel']
			}
		},

		//---------------------------------------------------------------------
		// требуется ли показывать фильтр
		//---------------------------------------------------------------------
		isNeedShowFilter() {
			let k1 = this.Groups['without-panel'] ? Object.keys(this.Groups['without-panel']).length : 0
			let k2 = this.Groups['with-panel'] ? Object.keys(this.Groups['with-panel']).length : 0
			// если есть шаблоны как с панелью, так и без
			if (k1 > 0 && k2 > 0) return true
			// если есть список с бэкапами
			if (this.backupField && this.backupField.list && this.backupField.list.length)
				return true
			// иначе - нет смысла показывать фильтр
			return false
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в DOM
	//=========================================================================
	created() {
		// сформируем основные данные
		this.initAllData()

		// установим первоначальное значение
		if (this.Field && this.Field.value)
		{
			// теперь значение
			this.setValue(this.Field.value, true)
		}
		else this.findSupportedTemplate()
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на сообщения - изменение выбранного тарифа
		EventBus.$on('w5-new-vds-plan-notice', this.handleChangePlan)

		// подписка на сообщение - смена текущей вкладки
		EventBus.$on('w5-change-active-tab', this.handleChangeActiveTab)

		// генерируем событие - запрос текущего выбранного плана
		EventBus.$emit('w5-new-vds-plan-notice-what')

		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от сообщений
		EventBus.$off('w5-new-vds-plan-notice', this.handleChangePlan)
		EventBus.$off('w5-change-active-tab', this.handleChangeActiveTab)

		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// виден ли шаблон
		//---------------------------------------------------------------------
		isTemplateVisible(Group) {
			// проверка параметра
			if (!Group || !Group['list'] || !Group['list'].length) return false

			// для сотрудников все видно
			if (this.$store.state.user_type === 'admin') return true

			// для клиентов производим фильтрацию по следующим правилам:
			// 1) при создании услуги - неактивные варианты не должны быть доступны
			// 2) при редактировании:
			// 2.1) должны отображаться только если они изначально выбраны
			// 2.2) если выбрано что-то другое - не должны отображаться
			if (this.action === 'create')
			{
				// 1) если в группе нет ни одного активного шаблона - невидим
				if (this.isActiveTemplate(Group) === false) return false
			}
			else if (this.action === 'update' || this.action === 'view')
			{
				// 2.2) если есть активные версии - всяко видно
				if (this.isActiveTemplate(Group) === true) return true
				// если все версии неактивны - может какая то из них равна начальному значениию?
				else return Group.list.some(el => {
					if (String(this.Field['_oldValue']) === String(el['id'])) return true
				})
			}

			// по умолчанию передаем все итемы
			return true
		},

		//---------------------------------------------------------------------
		// активена ли группа шаблонов
		//---------------------------------------------------------------------
		isActiveTemplate(Group) {
			// проверка параметра
			if (!Group || !Group['list'] || !Group['list'].length) return false
			// если есть хотя бы один активный шаблон в текущей группе
			return Group['list'].some(el => {
				if (el['id'] !== undefined && el['id'] !== null && el['id'] !== false && el['active'] === true)
					return true
			})
		},

		//---------------------------------------------------------------------
		// есть ли в заданном списке выбранный шаблон, если есть - шаблон
		//---------------------------------------------------------------------
		isSelectedVersion(List) {
			if (!List || !List.length) return false
			let answer = false
			List.some(el => {
				if (String(el['id']) === String(this.curValue))
				{
					answer = el
					return true
				}
			})

			return answer
		},

		//---------------------------------------------------------------------
		// проверяет: все ли шаблоны в группе не поддерживают текущий план
		//---------------------------------------------------------------------
		isNotGroupForPlan(Group) {
			// если нет группы
			if (!Group || !Group.list || !Group.list.length) return true
			// если нет плана - никто не поддерживает его
			if (!this.curPlan) return true
			// ищем в группе хотя бы один шаблон, который поддерживает план
			return !Group.list.some(item => {
				// если текущий план есть в списке поддерживаемых
				if (item && item.plans && item.plans.length && item.plans.indexOf(this.curPlan) > -1)
					return true
			})
		},

		//---------------------------------------------------------------------
		// ищем шаблон по его ID во всех списках
		//---------------------------------------------------------------------
		findTemplateById(ID, onlyInActiveFilter = false) {
			// готовим ответ
			let answer = null
			let curFilter = ''

			// если нужно искать только в текущем фильтре
			if (onlyInActiveFilter)
			{
				curFilter = this.activeFilter
				for (let key in this.Groups[curFilter])
				{
					let group = this.Groups[curFilter][key]
					if (group && group.list)
					{
						group.list.some(item => {
							if (String(item.id) === String(ID))
							{
								answer = item
								return true
							}
						})
					}

					if (answer) break
				}

				return answer
			}

			// нужно искать вообще везде
			// в первом фильтре
			curFilter = 'without-panel'
			for (let key in this.Groups[curFilter])
			{
				let group = this.Groups[curFilter][key]
				if (group && group.list)
				{
					group.list.some(item => {
						if (String(item.id) === String(ID))
						{
							answer = item
							return true
						}
					})
				}

				if (answer) break
			}

			// во втором фильтре - только если еще не найдено
			if (!answer)
			{
				curFilter = 'with-panel'
				for (let key in this.Groups[curFilter])
				{
					let group = this.Groups[curFilter][key]
					if (group && group.list)
					{
						group.list.some(item => {
							if (String(item.id) === String(ID))
							{
								answer = item
								return true
							}
						})
					}

					if (answer) break
				}
			}

			return answer
		},

		//---------------------------------------------------------------------
		// ищем первый, поддерживаемый текущим планом, шаблон
		//---------------------------------------------------------------------
		findSupportedTemplate() {
			// начинаем с первоначального значения - заданным родителем
			let id = this.value
			// получим шаблон по его id
			let template = this.findTemplateById(id)
			// проверим поддерживается ли тариф
			if (template && template.plans && template.plans.indexOf(this.curPlan) > -1)
			{
				// ставим значение
				this.setValue(id, true)
				return
			}

			// но может быть так что первоначальное значение не поддерживает выбранный план
			// проверим старое значение
			id = this.Field['_oldValue']
			// получим шаблон по его id
			template = this.findTemplateById(id)
			// проверим поддерживается ли тариф
			if (template && template.plans && template.plans.indexOf(this.curPlan) > -1)
			{
				// ставим значение
				this.setValue(id, true)
				return
			}

			// если дошли до сих пор - значит нужно найти первый шаблон
			// который бы поддерживал текущий тариф
			id = false
			// в первом фильтре
			let curFilter = 'without-panel'
			for (let key in this.Groups[curFilter])
			{
				let group = this.Groups[curFilter][key]
				if (group && group.list)
				{
					group.list.some(item => {
						if (item && item.plans && item.plans.indexOf(this.curPlan) > -1)
						{
							id = item.id
							return true
						}
					})
				}

				if (id) break
			}

			// во втором фильтре - только если еще не найдено
			if (!id)
			{
				curFilter = 'with-panel'
				for (let key in this.Groups[curFilter])
				{
					let group = this.Groups[curFilter][key]
					if (group && group.list)
					{
						group.list.some(item => {
							if (item && item.plans && item.plans.indexOf(this.curPlan) > -1)
							{
								id = item.id
								return true
							}
						})
					}

					if (id) break
				}
			}

			// если нашли - ставим значения
			if (id)
			{
				// сначала активный фильтр
				this.activeFilter = curFilter
				// теперь значение
				this.setValue(id, true)
			}
		},

		//---------------------------------------------------------------------
		// ищем первый, поддерживаемый текущим планом, шаблон в текущей вкладке
		//---------------------------------------------------------------------
		findSupportedTemplateWithFilter() {
			// начинаем с текущего значения - если оно задано
			if (this.curValue)
			{
				// получим шаблон по его id и по текущему фильтру
				let template = this.findTemplateById(this.curValue, true)
				// проверим поддерживается ли тариф
				if (template && template.plans && template.plans.indexOf(this.curPlan) > -1)
				{
					// да - тариф поддерживает текущий шаблон, ничего делать не нужно
					return
				}
			}

			// если дошли до сих пор - значит нужно найти первый шаблон
			// который бы поддерживал текущий тариф
			let id = false
			// только в текущем фильтре
			let curFilter = this.activeFilter
			for (let key in this.Groups[curFilter])
			{
				let group = this.Groups[curFilter][key]
				if (group && group.list)
				{
					group.list.some(item => {
						if (item && item.plans && item.plans.indexOf(this.curPlan) > -1)
						{
							id = item.id
							return true
						}
					})
				}

				if (id) break
			}

			// если нашли - ставим значения
			if (id)
			{
				// теперь значение
				this.setValue(id, true)
			}
			// если нет - обнуляем
			else this.setValue(null, true)
		},

		//---------------------------------------------------------------------
		// получает имя шаблона и версию из наименования шаблона
		//---------------------------------------------------------------------
		getGroupAndVersion(Name) {
			// наименование и версия по умолчанию
			let _nm = false
			let _vr = false

			// получим название OS
			let _parts = Name.split(' ')
			for (let j = 0; j < _parts.length; j++)
			{
				// если это версия
				if (/^[0-9.-]+$/.test(_parts[j]))
				{
					// склеиваем хвост
					_vr = _parts.slice(j).join(' ')
					// конец
					break
				}
				else
				{
					// это не цифры - значит будем считать что это наименование
					if (!_nm) _nm = _parts[j]
					else _nm += ' ' + _parts[j]
				}
			}

			// форматируем наименование
			_nm = _nm.replace(/centos/i, 'CentOS')
				.replace(/ubuntu/i, 'Ubuntu')
				.replace(/debian/i, 'Debian')
				.replace(/windows/i, 'Windows')
				.replace(/bsd/i, 'BSD')
				.replace(/server/i, 'Server')
				.replace(/web/i, 'Web')

			return {
				name: _nm,
				version: _vr
			}
		},

		//---------------------------------------------------------------------
		// инициализация основных данных
		//---------------------------------------------------------------------
		initAllData() {
			// запоминаем текущую вкладку
			let _oldTab = this.activeFilter

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// обнуление основных данных
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.activeFilter = ''
			this.Groups = {
				'without-panel': {},
				'with-panel': {}
			}
			this.curValue = null

			// если нет входящих данных
			if (!this.Field || !this.Field.list || !this.Field.list.length)
			{
				this.setValue(this.curValue, true)
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// ищем группы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let valueWithPanel = false
			for (let idx in this.Field.list)
			{
				// текущий шаблон
				let template = this.Field.list[idx]

				// группа шаблона
				let groupAndVersion = this.getGroupAndVersion(template['name'])

				// если не удалось определить наименование
				if (!groupAndVersion) continue
				if (!groupAndVersion['name']) continue

				// ссылка на группу
				let group = this.Groups['without-panel']
				let withInstruction = false
				if ('has_instruction' in template && template['has_instruction'] === true)
				{
					group = this.Groups['with-panel']
					withInstruction = true
				}

				if (!group) group = {}
				if (!group[groupAndVersion['name']]) group[groupAndVersion['name']] = {}

				// ссылка на объект шаблона
				let data = group[groupAndVersion['name']]

				// записываем - общие данные
				data['showList'] = false
				data['image'] = template['image']

				// если это сотрудник - фильтрация неактивных не нужна
				if (this.$store.state.user_type === 'admin')
				{
					// список
					if (!data['list']) data['list'] = []
					// добавим версию в список
					data['list'].push({
						id: template['id'],
						fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
						version: groupAndVersion['version'],
						active: template['active'],
						sshkey: template['sshkey'],
						plans: template['plans'],
						limits: template['limits']
					})
				}
				// для клиентов нужно профильтровать неактивные версии
				else
				{
					// активные передаем все
					if ('active' in template && template['active'] === true)
					{
						// список
						if (!data['list']) data['list'] = []
						// добавим версию в список
						data['list'].push({
							id: template['id'],
							fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
							version: groupAndVersion['version'],
							active: template['active'],
							sshkey: template['sshkey'],
							plans: template['plans'],
							limits: template['limits']
						})
					}
					// неактивная версия
					else
					{
						// добавим только если это редактирование или просмотр
						if (this.action === 'update' || this.action === 'view')
						{
							// и если это выбранная версия
							if (String(this.Field['_oldValue']) === String(template['id']))
							{
								// список
								if (!data['list']) data['list'] = []
								// добавим версию в список
								data['list'].push({
									id: template['id'],
									fullName: groupAndVersion['name'] + (withInstruction && groupAndVersion['version'] ? ' ' + groupAndVersion['version'] : ''),
									version: groupAndVersion['version'],
									active: template['active'],
									sshkey: template['sshkey'],
									plans: template['plans'],
									limits: template['limits']
								})
							}
						}
					}
				}

				// значение тут?
				if (String(this.value) === String(template['id']))
					valueWithPanel = withInstruction ? 'with-panel' : 'without-panel'
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// значение фильтра
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если старое значение было "бэкапы" и есть закешированное значение
			if (_oldTab === 'backup' && this.curBackup && this.curBackup.id)
			{
				// смотрим в текущий список бэкапов
				let _curBackupInList = false
				// ищем закешированное значение
				if (this.backupField && this.backupField.list && this.backupField.list.length)
				{
					_curBackupInList = this.backupField.list.some(b => {
						if (b && b.id === this.curBackup.id)
						{
							return true
						}
					})
				}

				// если все есть - оставляем вкладку на бэкапах
				if (_curBackupInList)
				{
					// шаблон обнулим
					this.setValue(null, true)
					this.activeFilter = 'backup'
					// передадим значение фильтра родителю
					this.$emit('templateTab', this.activeFilter)
					return
				}
			}

			let k1 = Object.keys(this.Groups['without-panel']).length
			let k2 = Object.keys(this.Groups['with-panel']).length
			// если есть шаблоны как с панелью, так и без
			if (k1 > 0 && k2 > 0)
			{
				// если определили по значению
				if (valueWithPanel)
				{
					this.activeFilter = valueWithPanel
				}
				// если значения так и нет
				else
				{
					this.activeFilter = 'without-panel'
				}
			}
			// если есть только шаблоны без панели
			else if (k1 > 0) this.activeFilter = 'without-panel'
			// если есть только шаблоны с панелью
			else if (k2 > 0) this.activeFilter = 'with-panel'

			// передадим значение фильтра родителю
			this.$emit('templateTab', this.activeFilter)

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// установка текущего значения
		//---------------------------------------------------------------------
		setValue(Value, needEmitInputEvent = false, needTemplateToBus = true) {
			// если задали значение
			if (Value !== undefined && Value !== null)
			{
				// эмуляция фокуса
				this.$emit('focus')
				// присвоим значение
				let val = parseInt(Value)
				if (!isNaN(val))
				{
					this.curValue = val
					// сообщаем родителю что у нас поменялось значение
					if (needEmitInputEvent) this.$emit('input', String(this.curValue))
					// передаем в эфир данные выбранного шаблона
					if (needTemplateToBus)
					{
						EventBus.$emit(
							'w5-new-vds-template-notice-what',
							this.findTemplateById(val)
						)
					}
				}
			}
			else
			{
				this.curValue = null
				if (needEmitInputEvent) this.$emit('input', null)
				// передаем в эфир данные выбранного шаблона
				if (needTemplateToBus)
					EventBus.$emit('w5-new-vds-template-notice-what', null)
			}
		},

		//---------------------------------------------------------------------
		// восстановление значения шаблона из кеша
		//---------------------------------------------------------------------
		restoreTemplateValue() {
			// если есть старое выбранное значение
			if (this.oldValues[this.activeFilter])
			{
				// получим шаблон по его id и по текущему фильтру
				let template = this.findTemplateById(this.oldValues[this.activeFilter])
				// если нашли такой шаблон - выбираем его
				if (template)
				{
					// ставим его
					this.setValue(this.oldValues[this.activeFilter], true)
					return
				}
			}

			// если мы здесь - значит или нет старого значения, или оно уже протухло
			// нужно выбрать первый шаблон
			let id = false
			// в текущем фильтре
			let curFilter = this.activeFilter
			for (let key in this.Groups[curFilter])
			{
				let group = this.Groups[curFilter][key]
				if (group && group.list)
				{
					group.list.some(item => {
						if (item && item.id)
						{
							id = item.id
							return true
						}
					})
				}
				if (id) break
			}
			// если нашли - ставим значения
			if (id)
			{
				// теперь значение
				this.setValue(id, true)
			}
			// если не смогли найти подходящего значения - обнуляем
			else this.setValue(null, true)
		},

		//---------------------------------------------------------------------
		// изменение фильтра пользователем
		//---------------------------------------------------------------------
		toggleFilter(filterValue) {
			// эмуляция фокуса
			this.$emit('focus')

			// если фильтр не поменялся
			if (this.activeFilter === filterValue) return

			// закрываем все селекторы (списки в шаблонах с версиями)
			this.handleClick(null)

			// если сейчас мы не в бэкапах - запомним старое выбранное значение шаблона
			if (this.activeFilter !== 'backup')
				this.oldValues[this.activeFilter] = this.curValue

			// меняем значение фильтра (вкладку)
			this.activeFilter = filterValue
			// сразу оповестим родителя
			this.$emit('templateTab', filterValue)

			// если ушли с бэкапов
			if (this.activeFilter !== 'backup')
			{
				// поле "backup_id" обнуляем,
				// но текущее значение оставляем как есть для кеша
				this.$emit('backupValueChanged', null)

				// восстановим значение шаблона из кеша
				this.restoreTemplateValue()
			}
			// если пришли во вкладку с бэкапами
			else
			{
				// изменится список бэкапов
				// логика в обработчике изменения списка бэкапов

				// так же нужно обнулить значение шаблона
				this.setValue(null, true)
				EventBus.$emit('w5-new-vds-template-notice-what', this.curBackup)
			}
		},

		//---------------------------------------------------------------------
		// кликнули по группе шаблонов
		//---------------------------------------------------------------------
		handleClick(groupName) {
			// здесь запомним группу шаблонов по которой кликнули
			let selected = null

			// закрываем все шаблоны, кроме выбранного в первом фильтре
			let curFilter = 'without-panel'
			for (let key in this.Groups[curFilter])
			{
				// если по этой группе кликнули
				if (groupName === key) selected = this.Groups[curFilter][key]
				// закрываем все селекторы
				this.$set(this.Groups[curFilter][key], 'showList', false)
			}

			// во втором фильтре
			curFilter = 'with-panel'
			for (let key in this.Groups[curFilter])
			{
				// если по этой группе кликнули
				if (groupName === key) selected = this.Groups[curFilter][key]
				// закрываем все селекторы
				this.$set(this.Groups[curFilter][key], 'showList', false)
			}

			// проверим выбранную группу шаблонов
			if (selected && selected.list)
			{
				// если там всего одно значение
				if (selected.list.length === 1)
				{
					// тогда выберем его - только если есть шаблон с планом
					if (!this.isNotGroupForPlan(selected))
					{
						let temp = selected.list[0]
						if (temp && temp.id) this.setValue(temp.id, true)
					}
				}
				// значений несколько
				else
				{
					// открываем селектор - только если есть шаблон с планом
					if (!this.isNotGroupForPlan(selected))
						selected['showList'] = true
					else
						selected['showList'] = false
				}
			}

			// обновим интерфейс
			this.$forceUpdate()
		},

		//---------------------------------------------------------------------
		// обработчик события изменения плана
		//---------------------------------------------------------------------
		handleChangePlan(data) {
			let planId = parseInt(data)

			// проверка
			if (!data || isNaN(planId))
			{
				this.curPlan = null
				this.setValue(null, true)
				this.curBackup = null
				this.$emit('backupValueChanged', null)
				return
			}

			// запоминаем текущий тарифный план
			this.curPlan = planId

			// если мы в какой то вкладке с шаблонами
			if (this.activeFilter !== 'backup')
			{
				// установим значение шаблона
				this.findSupportedTemplateWithFilter()

				// если это просмотр VDS - обрабатываем событие только один раз
				if (this.action === 'view')
					EventBus.$off('w5-new-vds-plan-notice', this.handleChangePlan)
			}
		},

		//---------------------------------------------------------------------
		// обработчик события изменения активной вкладки - запрос на изменение
		//---------------------------------------------------------------------
		handleChangeActiveTab(tab) {
			if (this.activeFilter === tab) return
			this.$nextTick(() => this.toggleFilter(tab))
		},

		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// нажали клавишу ESC
			if (e.keyCode === 27)
			{
				// закрываем все селекторы
				this.handleClick(null)
			}
		},

		//---------------------------------------------------------------------
		// обработка клика
		//---------------------------------------------------------------------
		clickHandler(e) {
			// закрываем все селекторы
			this.handleClick(null)
		},

		//---------------------------------------------------------------------
		// обработка клика по конкретному шаблону в селекторе
		//---------------------------------------------------------------------
		handleSelectTemplate(Template) {
			// проверка
			if (!Template || !Template.id || !Template.plans || !Template.plans.length) return
			// поддерживается ли текущий план
			if (Template.plans.indexOf(this.curPlan) > -1)
			{
				// установка значения
				this.setValue(Template.id, true)
				// закрытие всех шаблонов
				this.handleClick(null)
			}
		},

		//---------------------------------------------------------------------
		// поменялось значение поля "backup_id"
		//---------------------------------------------------------------------
		// выбор значения
		onSelectValue(value) {
			// сообщаем родителям
			this.$emit('backupValueChanged', value)

			// сообщаем в эфир
			EventBus.$emit('w5-new-vds-template-notice-what', value)
		},
		// фокус
		onBackupFocus() {
			this.$emit('focus')
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// пустое значение или нет
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		notEmpty(value) {
			// пустое значение
			if (value === undefined || value === null) return false
			if (!value || value === '' || value === 'emptyValue') return false

			// другие пустые значения
			if (String(value) === '') return false

			// не пустое
			return true
		},

		//---------------------------------------------------------------------
		// переход в форму создания бэкапа
		//---------------------------------------------------------------------
		backupCreateButtonClick() {
			this.$emit('createBackup')
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдаем изменение списка
	//=========================================================================
	watch: {
		'Field.list': function(list) {
			// сформируем основные данные
			this.initAllData()

			// если по итогу у нас выбран бэкап
			if (this.activeFilter === 'backup' && this.curBackup)
			{
				return
			}

			// иначе установим первоначальное значение для шаблона
			if (!this.curValue) this.findSupportedTemplate()
		},
		// поменялся список с бэкапами - сменили аккаунт
		'backupField.list': function(newList, oldList) {
			// если пришел пустой список
			if (!newList || !newList.length)
			{
				// обнуляем поле бэкапов
				this.curBackup = null
				this.$nextTick(() => {
					this.$emit('backupValueChanged', this.curBackup)
					EventBus.$emit('w5-new-vds-template-notice-what', this.curBackup)
				})
				return
			}

			// если нет изменений в списке
			if (Helper.arrayCompare(newList, oldList, ['active', 'enable']))
			{
				EventBus.$emit('w5-new-vds-template-notice-what', this.curBackup)
				return
			}

			// если список не пустой и есть указание по выбору бэкапа (создание VDS из резервной копии)
			if (window && window.sessionStorage)
			{
				let _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup')
				if (_crtFromBackup)
				{
					// сразу обнулим хранилище
					window.sessionStorage.removeItem('create-vds-from-backup')

					// конвертируем
					let _crtStore = null
					try {
						_crtStore = JSON.parse(_crtFromBackup)
					}
					catch (e)
					{
						_crtStore = null
					}

					// если бэкап задан
					if (_crtStore && _crtStore.service_id)
					{
						// поменяем значение
						this.curBackup = { id: String(_crtStore.service_id), isStore: true }
					}
				}
			}

			// если активна вкладка с бекапами (при этом список не пустой)
			if (this.activeFilter === 'backup')
			{
				// установим первоначальное значение
				let _oldId = this.curBackup && this.curBackup.id ? String(this.curBackup.id) : ''
				this.curBackup = null

				// ищем значение
				newList.some(item => {
					if (item.active && item.enable &&
						item.plans && item.plans.length && item.plans.indexOf(this.curPlan) > -1)
					{
						// если не было вообще значение - можно запомнить и первое
						if (_oldId === '' && !this.curBackup)
							this.curBackup = Object.assign({}, item)

						// если в списке есть старое значение
						if (String(item.id) === _oldId)
						{
							this.curBackup = Object.assign({}, item)
							return true
						}
					}
				})
			}
			// если активна вкладка с шаблонами (при этом список не пустой)
			else
			{
				// просто обнуляем поле бэкапов
				this.curBackup = null
			}

			// меняем значение у настоящего поля "backup_id"
			this.$nextTick(() => {
				this.$emit('backupValueChanged', this.curBackup)
				EventBus.$emit('w5-new-vds-template-notice-what', this.curBackup)
			})
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Multiselect,
		backupChoiceComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-vds-plan-list-filter-wrapper {
	margin: 10px 0 20px;
}

.w5-vds-plan-list-filter {
	display: inline-block;
	text-align: left;
	font-weight: 400;
	padding-bottom: 5px;
	cursor: pointer;
	font-size: 15px;
	transition: color .2s;
	margin-right: 20px;
}
.w5-vds-plan-list-filter:hover {
	color: #3ba3ff;
}
.w5-vds-plan-list-filter.first {
	/*margin-right: 0;*/
}
.w5-vds-plan-list-filter.last {
	margin-left: 0;
	margin-right: 0;
}
.w5-vds-plan-list-filter.active {
	color: #2c8ad8;
	border-bottom: 2px solid #2c8ad8;
}


.w5-vds-plan-list-item-down.template_id {
	border-color: #ddd !important;
    padding: 0;
}

.w5-vds-plan-list-item.template_id {
	height: 150px;
	margin: 10px 0;
	margin-right: 15px;
	margin-bottom: 10px;
}

.w5-vds-plan-list-item-down.template_id .selector {
    z-index: 100;
    position: relative;
    background: white;

    border-bottom: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
    border-left: 1px solid #ddd !important;	
    border-radius: 0 0 4px 4px;
}
.w5-vds-plan-list-item:hover div.selector {
	border-color: #3ba3ff !important
}
.w5-vds-plan-list-item.selected div.selector {
	border-color: #3ba3ff !important
}

.w5-vds-plan-list-item-down.template_id .selector > div {
	padding: 10px;
}
.w5-vds-plan-list-item-down.template_id .selector > div.last {
	border-radius: 0 0 4px 4px;
}
.w5-vds-plan-list-item-down.template_id .selector > div.not-supported {
	color: #999;
}
.w5-vds-plan-list-item-down.template_id .selector > div:hover {
	background-color: #dceeff !important;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up {
	height: 110px;
}

.w5-vds-plan-list-item-up .gourp-title {
	line-height: 0.9;
	height: 26px;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	flex-direction: column;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up.full-and-round {
	height: 150px;
	border-radius: 4px !important;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up.full-and-round .gourp-title {
	height: 66px;
	line-height: 1.2;
}

/* неактивная группа шаблонов */
.not-active-item > .w5-vds-plan-list-item-up,
.not-active-item > .w5-vds-plan-list-item-down {
	background-color: #f9f9f9;
}
.not-active-item.for-users {
	cursor: not-allowed;
}

/* блок который содержит только текст */
.item-with-only-text {
	height: 45px;
    display: block;
    line-height: 45px;
    overflow: hidden;
}

/* прочерк в нижней части группы шаблонов */
.item-with-only-line {
	height: 45px;
    display: block;
    line-height: 45px;
    text-align: center;
    padding-top: 21px;
    padding-left: 34px;
}
.item-with-only-line > .line {
	width: 50px;
	height: 1px;
	border-top: 1px solid #ddd;
}

/* засереная группа шаблонов */
.w5-vds-plan-list-item.template_id.not-for-current-plan {
	opacity: 0.7;
    filter: grayscale(1);
    cursor: not-allowed;
}
.not-for-current-plan > .w5-vds-plan-list-item-up > .gourp-title {
	color: #777;
}
.not-for-current-plan > .w5-vds-plan-list-item-down > .item-with-only-text {
	color: #777;
}
.w5-vds-plan-list-item.template_id.not-for-current-plan:hover div.w5-vds-plan-list-item-up {
	background-color: white !important;
    border-color: #ddd !important;
}
.w5-vds-plan-list-item.template_id.not-for-current-plan:hover div.w5-vds-plan-list-item-down {
    border-color: #ddd !important;
}

/* уголок селектора версий */
.corner {
	position: absolute;
	display: inline-block;

	border: 4px solid transparent;
	border-top: 5px solid #999;
	width: 0;
	height: 0;

	right: 10px;
	top: 20px;
	z-index: 1;
}
.corner.for-open-block {
	border-top: none;
	border-bottom: 5px solid #999;
	top: 18px;	
}

/* под мобилу */
@media (max-width: 380px) {
	.w5-vds-plan-list-filter {
		font-size: 14px;
		text-align: left;
		margin-top: 10px;
		/*width: 100%;*/
	}
	.w5-vds-plan-list-filter.first {
		margin-right: 0;
	}
	.w5-vds-plan-list-filter.last {
		margin-left: 0;
	}

	.w5-vds-plan-list-filter.active {
		font-weight: 500;
		/*border-bottom: none;*/
		padding-bottom: 0;
	}
}

@media (max-width: 767px) {
	.w5-vds-plan-list-filter.last {
		margin-left: 0;
	}

	.w5-vds-plan-list-filter {
		font-size: 14px;
		text-align: left;
		margin-top: 10px;

		display: inline-block;
	}
}
</style>

<style scoped>
.empty-backup-list .empty-message { display: inline-block }

.w5-field-placeholder {
	position: absolute;
	left: 20px;
	height: 45px;
	width: calc(100% - 30px);
	padding: 3px 0;
	line-height: 39px;
	font-weight: 400;
	color: #ccc;
	user-select: none;
	pointer-events: none;
	z-index: 0;
}

.w5-field-placeholder .required-field {
	color: #ccc;
}

.w5-field-placeholder.active {
	font-size: 75%;
	line-height: 1;
	color: #9f9f9f;
}

.w5-field-placeholder.active .required-field {
	color: red;
}

</style>



// WEBPACK FOOTER //
// template.vue?9642ad9a